import React, { useState, useEffect } from 'react';
import { MapPin, Navigation } from 'lucide-react';

const RadiusSelector = ({ radius, onRadiusChange, maxRadius = 50 }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [sliderRef, setSliderRef] = useState(null);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !sliderRef) return;

    const rect = sliderRef.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    const newRadius = Math.round((percentage / 100) * maxRadius);
    
    onRadiusChange(newRadius);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, sliderRef]);

  const percentage = (radius / maxRadius) * 100;

  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Navigation className="w-5 h-5 text-indigo-600" />
          <span className="text-sm font-medium text-gray-900">Search Radius</span>
        </div>
        <span className="text-sm font-bold text-indigo-600">{radius} km</span>
      </div>
      
      <div className="relative" ref={setSliderRef}>
        <div className="h-2 bg-gray-200 rounded-full">
          <div 
            className="h-2 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full transition-all duration-200"
            style={{ width: `${percentage}%` }}
          />
        </div>
        
        <div
          className="absolute top-1/2 transform -translate-y-1/2 w-6 h-6 bg-white border-2 border-indigo-600 rounded-full shadow-lg cursor-pointer hover:scale-110 transition-transform"
          style={{ left: `calc(${percentage}% - 12px)` }}
          onMouseDown={handleMouseDown}
        >
          <div className="w-full h-full flex items-center justify-center">
            <MapPin className="w-3 h-3 text-indigo-600" />
          </div>
        </div>
      </div>
      
      <div className="flex justify-between text-xs text-gray-500 mt-2">
        <span>1 km</span>
        <span>{maxRadius} km</span>
      </div>
    </div>
  );
};

export default RadiusSelector;
